module["exports"] = [
  "####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/postcode.js
// module id = 378
// module chunks = 0